export default "__VITE_ASSET__1ffb5136__"